import React from 'react';
import { Music2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-navy px-4 py-20 text-center text-white md:py-24" data-id="element-61" data-mp="3n4wdgbtdixoq">
      <Reveal className="mx-auto max-w-3xl" data-id="element-62" data-mp="3s2xwwxupoz0q">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-brand-orange" data-id="element-63" data-mp="welbgh1x51d">
          <Music2Icon className="h-6 w-6" aria-hidden="true" data-id="element-64" data-mp="2zejy4fvstyo4" />
        </div>
        <h2 className="mt-6 text-3xl font-extrabold leading-tight md:text-5xl" data-id="element-65" data-mp="34c27u8hn4hx6">
          Bereit, jeder Klasse{' '}
          <span className="font-script italic text-brand-orange" data-id="element-66" data-mp="39an7o6szczl3">Musik</span>{' '}
          näherzubringen?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/70" data-id="element-67" data-mp="3e3y3ze061xyr">
          10 Bände + 5 exklusive Boni — sofort einsatzbereit, für nur 19 €.
        </p>
        <CTAButton animated className="mt-9 px-10 py-5" data-id="element-68" data-mp="2llkjeg3uc8hm" />
      </Reveal>
    </section>;
}